module.exports = __webpack_public_path__ + "img/fecharx.a1171aef.svg";